export function downloadFile(document: Document, url: string) {
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.download = 'untitled-download'
  link.click()
  link.remove()
}

export function downloadJsonFile(data: unknown, filename: string) {
  const sanitizedFilename = filename.replace(/[/\\:*?"<>|]/g, '_').trim()
  const safeFilename = sanitizedFilename || 'export'
  const jsonString = JSON.stringify(data, null, 2)
  const blob = new Blob([jsonString], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${safeFilename}.json`
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
